import React from 'react';

const Diamond = (props) => {
    const { color } = props;

    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 803.8 803.8"
            style={{ enableBackground: 'new 0 0 803.8 803.8', width: '100%' }}
            xmlSpace="preserve"
        >
            <filter filterUnits="userSpaceOnUse" height="803.764" id="Path_3732" width="803.764" x="0" y="0">
                <feOffset dy="3" input="SourceAlpha"></feOffset>
                <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
                <feFlood floodOpacity="0.451"></feFlood>
                <feComposite in2="blur" operator="in"></feComposite>
                <feComposite in="SourceGraphic" operator="over"></feComposite>
            </filter>
            <g transform="matrix(1, 0, 0, 1, 0, 0)" style={{ filter: 'url(#Path_3732)' }}></g>
            <path
                id="Path_3732-2"
                style={{ fill: `${color}` }}
                d="M427.5,34.7l341.5,341.5c14.2,14.2,14.2,37.2,0,51.3L427.5,769.1c-14.2,14.2-37.2,14.2-51.3,0
	L34.7,427.5c-14.2-14.2-14.2-37.2,0-51.3L376.2,34.7C390.4,20.5,413.4,20.5,427.5,34.7C427.5,34.7,427.5,34.7,427.5,34.7z"
            />
        </svg>
    );
};

export default Diamond;
